"use client";

import { useState, useEffect, useMemo } from "react";
import { getCategoriesForNavbar, type PublicCategoryForNavbar } from "@/app/lib/api/public";

export interface MenuItem {
  label: string;
  href: string;
  subItems?: {
    label: string;
    href: string;
    image_url?: string | null;
    percentage?: string | null;
  }[];
}

const staticMenuItems: MenuItem[] = [
  { label: "Okul Albumleri", href: "/okul-albumleri" },
  { label: "Duyurular Ve Kampanyalarımız", href: "/duyurular" },
  { label: "İletişim Bilgileri", href: "/iletisim" },
  { label: "Hakkımızda", href: "/hakkimizda" },
];

export function useCategories() {
  const [categories, setCategories] = useState<PublicCategoryForNavbar | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const [categoriesData] = await Promise.all([
          getCategoriesForNavbar(),
        ]);
        setCategories(categoriesData);
      } catch (error) {
        setError("Failed to fetch categories");
        console.error("Failed to fetch categories:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const menuItems: MenuItem[] = useMemo(() => [
    {
      label: "Sipariş Ver",
      href: "/albumler",
      subItems: categories?.categories.map(category => ({
        label: category.category,
        href: `/albumler/${category.url}`,
        image_url: category.image_url,
        percentage: category.percentage?.toString() || null,
      })),
    },
    {
      label: "Kanvas",
      href: "/kanvas",
      subItems: categories?.canvasCategories.map(category => ({
        label: category.category,
        href: `/kanvas/${category.url}`,
        image_url: category.image_url,
        percentage: category.percentage?.toString() || null,
      })),
    },
    {
      label: "Fotoğraf Baskılar",
      href: "/baski",
      subItems: categories?.printCategories.map(category => ({
        label: category.category,
        href: `/baski/${category.url}`,
        image_url: category.image_url,
        percentage: category.percentage?.toString() || null,
      })),
    },
    // {
    //   label: "Hediyelik",
    //   href: "/hediye",
    //   subItems: categories?.giftCategories.map(category => ({
    //     label: category.category,
    //     href: `/hediye/${category.url}`,
    //     image_url: category.image_url,
    //     percentage: category.percentage?.toString() || null,
    //   })),
    // },
    ...staticMenuItems,
  ], [categories]);

  return {
    categories,
    menuItems,
    isLoading,
    error,
  };
}